export default function setAgentPreferences(context, preferences) {
  context.stores.agentPreferences.set(preferences);
  context.stores.agentPreferencesLocal.set(preferences);
  const agentId = context.stores.currentAgent.get().id;
  const orgId = context.stores.auth.get().getOrgId();
  context.gateways.agentPreferences.replace({ agentId, orgId }, preferences.toJs()).catch(() => {});
}
